import endpoints from "./endpoints";
import siteSetting from "./siteSetting";

export default [
  {
    name: "Feedback",
    title: "Customer Help"
  },
  {
    name: "Events/Corporate Sales",
    action: () => {
      window.location.href = endpoints.eventsPage;
    },
    title: "Events/Corporate Sales"
  },
  {
    name: "Real Estate",
    title: "Real Estate"
  },
  {
    name: "Vendor",
    title: "Vendor"
  },
  {
    name: "Press",
    title: "Press"
  },
  {
    name: "Donations",
    action: history => {
      const countryPrefix = /^(.*?)\/contact(?:\/|$)/.exec(history?.location?.pathname || '')?.[1] || '';
      const path = `${countryPrefix}${endpoints.donationPage}`;
      if (history) history.push(path);
      else window.location.href = path;
    },
    title: "Donations"
  }
];

export const customerHelpSectionKeys = {
  DELIVERY_EXPERIENCE: "delivery-experience",
  WEBSITE_APP_FEEDBACK: "website-app-feedback",
  IN_STORE_EXPERIENCE: "in-store-experience",
  FOOD_SAFETY: "food-safety",
  SAFETY_INCIDENT: "safety-incident",
  GIFT_CARD_INQUIRY: "gift-card-inquiry",
  TAX_EXEMPT_INQUIRY: "tax-exempt-inquiry",
  SOMETHING_ELSE: "something-else"
}

export const customerHelpSettings = [
  {
    siteSetting: siteSetting.CUSTOMER_HELP_ORDER_INQUIRY,
    title: "Delivery Experience",
    key: customerHelpSectionKeys.DELIVERY_EXPERIENCE
  },
  {
    siteSetting: siteSetting.CUSTOMER_HELP_WEBSITE_APP_FEEDBACK,
    title: "Website / App Feedback",
    key: customerHelpSectionKeys.WEBSITE_APP_FEEDBACK
  },
  {
    siteSetting: siteSetting.CUSTOMER_HELP_IN_STORE_EXPERIENCE,
    title: "In-Store Experience",
    key: customerHelpSectionKeys.IN_STORE_EXPERIENCE
  },
  {
    siteSetting: siteSetting.CUSTOMER_HELP_FOOD_SAFETY,
    title: "Allergen/Food Safety",
    key: customerHelpSectionKeys.FOOD_SAFETY
  },
  {
    siteSetting: siteSetting.CUSTOMER_HELP_SAFETY_INCIDENT,
    title: "Injury/Safety Incident",
    key: customerHelpSectionKeys.SAFETY_INCIDENT
  },
  {
    siteSetting: siteSetting.CUSTOMER_HELP_GIFT_CARD_INQUIRY,
    title: "Gift Card Inquiry",
    key: customerHelpSectionKeys.GIFT_CARD_INQUIRY
  },
  {
    siteSetting: siteSetting.CUSTOMER_HELP_TAX_EXEMPT_INQUIRY,
    title: "Tax Exempt Inquiry",
    key: customerHelpSectionKeys.TAX_EXEMPT_INQUIRY
  },
  {
    siteSetting: siteSetting.CUSTOMER_HELP_SOMETHING_ELSE,
    title: "Something Else",
    key: customerHelpSectionKeys.SOMETHING_ELSE
  }
];
